// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "header-3n6wr";
var _4 = "header__cell-2yzx4";
var _5 = "header__cell_short-WkNVh";
var _6 = "priceGroup-1-Mo0";
var _7 = "header__icon-cu-Ad";
var _8 = "title-xZ_bn";
var _9 = "travelTime-xT7jv";
var _a = "price-2QgId";
var _b = "arrowIcon-1s9bv";
var _c = "arrowIcon_flipped-SU9qY";
var _d = "fareGroup-1K9XF";
var _e = "fareGroup__logo-2ONsG";
var _f = "fareGroup__name-2j5SP";
var _10 = "details-1CFVK";
export { _1 as "__esModule", _2 as "tablet", _3 as "header", _4 as "header__cell", _5 as "header__cell_short", _6 as "priceGroup", _7 as "header__icon", _8 as "title", _9 as "travelTime", _a as "price", _b as "arrowIcon", _c as "arrowIcon_flipped", _d as "fareGroup", _e as "fareGroup__logo", _f as "fareGroup__name", _10 as "details" }
export default { "__esModule": _1, "tablet": _2, "header": _3, "header__cell": _4, "header__cell_short": _5, "priceGroup": _6, "header__icon": _7, "title": _8, "travelTime": _9, "price": _a, "arrowIcon": _b, "arrowIcon_flipped": _c, "fareGroup": _d, "fareGroup__logo": _e, "fareGroup__name": _f, "details": _10 }
